import { PaymentRequestActivity } from '@frontend/payments-request-activity';
import { styles } from './styles';

type RecentActivityListProps = {
  invoiceId?: string;
  locationId?: string;
};
export const RecentActivityList = ({ invoiceId, locationId }: RecentActivityListProps) => {
  return (
    <div className='card__recent-activity-details' css={styles.recentActivityDetails}>
      <PaymentRequestActivity
        invoiceId={invoiceId || ''}
        locationId={locationId || ''}
        compactView
        maxVisibleActivities={3}
      />
    </div>
  );
};
